import { render, staticRenderFns } from "./StandardCubeIcon.vue?vue&type=template&id=fc61bcec&scoped=true"
import script from "./StandardCubeIcon.vue?vue&type=script&lang=js"
export * from "./StandardCubeIcon.vue?vue&type=script&lang=js"
import style0 from "./StandardCubeIcon.vue?vue&type=style&index=0&id=fc61bcec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc61bcec",
  null
  
)

export default component.exports